import {GameViewDefaultBox} from "./games-view.default.box";
export const GameViewBox = GameViewDefaultBox;